import { resolvePermanentUrl } from '@/features/seo-listing/utils/resolve-permanent-url';

export interface FandomListApiItem {
  id: number;
  title: string;
  sec_title: string;
  is_universe: boolean;
  fanfic_cnt: number;
  permanentUrl?: string | null;
}

export interface FandomListItem {
  id: string;
  name: string;
  count: number;
  isUniverse: boolean;
  permanentUrl?: string;
}

/**
 * Map fandoms-custom search/list rows for filter UI.
 * Only trust API permanentUrl — do not synthesize /fanfics?fandoms=id when SEO is off
 * (CheckboxItem must render a span, not a legacy query link).
 */
export const mapFandomListItem = (fandom: FandomListApiItem): FandomListItem => {
  const itemId = fandom.id.toString();
  return {
    id: itemId,
    name: fandom.title || fandom.sec_title,
    count: fandom.fanfic_cnt || 0,
    isUniverse: fandom.is_universe || false,
    permanentUrl: resolvePermanentUrl(fandom.permanentUrl),
  };
};
